/**
  *  @fileOverview: 新版首页
  *  @creator: CaoYanqi
  *  @Date: 2019/6/5
  *  @Last Modified by: 
  *  @Last Modified time:
  */
import { addPolicies } from '@lima/seraphim-react';
import { Col, Modal, notification, Row, Spin } from 'antd';
import QueueAnim from 'rc-queue-anim';
import * as React from 'react';
import { connect } from 'react-redux';
import { axios_ } from "../../tools/axios_";
import { initPageNamesConfig, Utils } from '../../tools/utils';
import { getIsInactive, queryMerchantsAgreementStatus, refusedSignedAgreement } from '../common/api';
import PromptSceneBar from '../common/clues';
import FootTool from '../common/FootTool';
import MyModal, { agreementOrRejection, merchantsType, publicOrPrivate, topResponsiblePerson } from '../common/promotionServiceAgreement/index';
import { getUserPermissionInfo } from "../system/api/roleManage";
import { ActivityAndYesterday, CarouselCustom } from './components';
import ClientCount from './components/ClientCount';
import FeeCharts from './components/FeeCharts';
import NotifyCard from './components/NotifyCard';
import ProductCard from './components/ProductCard';
import Top5 from './components/Top5';
import './homePage_v2.less';


class HomePageV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      yesterdayPolicyCount: 0,
      yesterdayPremiumSum: '0.00',
      yesterdayPromotionFee: '0.00',

      customerCount: 0, // 客户总数
      yesterdayCustomerCount: 0,

      policyIncome: [],
      yesterdayAgencyTopFive: [],
      yesterdayProductTopFive: [],
      pageNamesConfig: {}, // 页面配置
      pageLoading: true,
      //提示语控制
      clues: {
        showClues: false,
        isConfirm: false,
        typeClues: merchantsType.新商户,
        date: ''
      },
      //协议控制
      agreement: {
        showAgreement: false,
        isClose: false,
        typeAgreement: merchantsType.新商户,
        date: '',
      },
      isShowInactive: sessionStorage.getItem('isShowInactive'),
      isShowPage: false
    }
  }

  componentDidMount() {
    this.getUserPermissionInfo();
    if (!this.state.isShowInactive) {
      getIsInactive(Utils.getOrgId()).then(res => {
        if (!res.data.data) {
            if(Utils.getOrgId() !=='1336272313067585536') {
                 Modal.info({
                    title: '系统提醒',
                    zIndex: '9998',
                    centered: true,
                    okText: '知道了',
                    content: (<div>由于您长时间未活跃，已暂停部分服务</div>),
                    onOk: () => {
                    this.setState({ isShowInactive: true });
                    sessionStorage.setItem('isShowInactive', true)
                    },
                });
            }

        }
      })
    }
     if(Utils.getOrgId() ==='1336272313067585536') {
        this.setState({ isShowInactive: false });
        sessionStorage.setItem('isShowInactive', false)
     }
    // 初始化页面配置（合作案）
    initPageNamesConfig('homePage', '', this.props.token).then(res => {
      if (res.data.status === 200) {
        this.setState({ pageNamesConfig: res.data.data || {} })
      }
    }).finally(() => {
      this.getCountData();

      this.getClientData();
      this.getAgencyTop5();
      this.getProductTop5();
      this.getRecent7();
      this.initAgreement();

    });
  }

  /**
   * 获取统计数据：
   */
  getCountData = () => {
    axios_({
      url: '/api/search/census/preday/policy/volume',
      method: 'get',
      headers: { 'Authorization': this.props.token }
    }).then(res => {
      if (res.data.status === 200 && res.data.data) {
        const _data = res.data.data;
        this.setState({
          yesterdayPolicyCount: _data.policyCount,
          yesterdayPremiumSum: _data.companyPremium,
          yesterdayPromotionFee: _data.companyIncome, //推广费
        })
      }
    })
  };
  // 客户统计
  getClientData = () => {
    axios_({
      url: '/api/intelligence/dashboard/newInfo',
      method: 'get',
      headers: { 'Authorization': this.props.token }
    }).then(res => {
      if (res.data.status === 200 && res.data.data) {
        const _data = res.data.data;
        this.setState({
          customerCount: _data.customerCount, //客户总数
          yesterdayCustomerCount: _data.yesterdayCustomerCount, // 昨日客户总数
        })
      }
    }).catch((err)=>{
        console.log('err', err);
    })
  };
  // 业务员to5
  getAgencyTop5 = () => {
    axios_({
      url: '/api/search/census/preday/top/agency',
      method: 'get',
      headers: { 'Authorization': this.props.token }
    }).then(res => {
      if (res.data.status === 200 && res.data.data) {
        const _data = res.data.data || [];
        this.setState({
          yesterdayAgencyTopFive: _data, //
        })
      }
    })
  };
  // 产品to5
  getProductTop5 = () => {
    axios_({
      url: '/api/search/census/preday/top/spu',
      method: 'get',
      headers: { 'Authorization': this.props.token }
    }).then(res => {
      if (res.data.status === 200 && res.data.data) {
        const _data = res.data.data || [];
        this.setState({
          yesterdayProductTopFive: _data, //
        })
      }
    })
  };
  // 近7日
  getRecent7 = () => {
    axios_({
      url: '/api/search/census/preweek/policy/premium',
      method: 'get',
      headers: { 'Authorization': this.props.token }
    }).then(res => {
      if (res.data.status === 200 && res.data.data) {
        const _data = res.data.data || [];
        this.setState({
          policyIncome: _data, //
        })
      }
    })
  };
  // 是否展示活动，只有商户展示（2家特殊商户不展示-创必承 、小司淘保），机构不展示
  isShowActivity = () => {
    const { companyLevelId, companyId } = Utils.getUserData();
    const ids = [
      '1086542588787994624',
      '1131889051286298624',
      '1075603369517211648',
      '1137976164155125760',
      '1146722604310474752',
    ];
    return companyLevelId === '10005' && ids.filter(id => id === companyId).length <= 0;
  };
  //获取用户按钮权限
  getUserPermissionInfo() {
    getUserPermissionInfo({ userId: Utils.getUserId() }).then(res => {
      if (res.status === 200) {
        setTimeout(() => {
          this.setState({ pageLoading: false });
        }, 1000);
        addPolicies(Object.keys(res.data.functionPermissionInfo).concat(ignorePermissions).filter((v) => v));
      }
    }).catch(e => {

    });
  }
  //初始化协议及提示语状态
  initAgreement = async () => {
    const isClose = sessionStorage.getItem('isClose');
    const userData = await axios_({ url: 'getUser', method: 'get', headers: { 'access-token': this.props.token } });
    const { data: { data } } = await queryMerchantsAgreementStatus(userData.data.orgId, userData.data.userId);
    const signAgreementEndTime = data.signAgreementEndTime ? data.signAgreementEndTime : null;
    let signAgreementSource = data.signAgreementSource + '';
    let signAgreementType = data.signAgreementType + '';
    const signFlag = data.signFlag;
    const orgSignType = data.orgSignType;
    if (!(signAgreementSource == merchantsType.新商户) && signFlag === topResponsiblePerson.不是顶级负责人) {
      this.setState({ ...this.state, clues: { ...this.state.clues, showClues: false }, agreement: { ...this.state.agreement, showAgreement: false } });
      return;
    }

    if (orgSignType === publicOrPrivate.对公商户) {
      if (signAgreementSource == merchantsType.取消下发协议商户 || signAgreementSource != merchantsType.公转私商户) {
        this.setState({ ...this.state, clues: { ...this.state.clues, showClues: false }, agreement: { ...this.state.agreement, showAgreement: false } });
        return;
      }
      if (isClose) {
        this.setState(state => {
          if (signAgreementType == agreementOrRejection.已经签署) {
            return { ...state, clues: { showClues: false, ...state.clues }, agreement: { showAgreement: false, ...state.agreement } }
          } else if (signAgreementType == agreementOrRejection.拒绝签署) {
            return { ...state, clues: { showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: true, typeAgreement: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
          } else {
            return { ...state, clues: { showClues: true, isConfirm: signAgreementType == agreementOrRejection.拒绝签署 ? false : true, typeClues: signAgreementType == agreementOrRejection.拒绝签署 ? merchantsType.拒绝签署商户 : signAgreementSource, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: signAgreementSource == merchantsType.新商户 ? false : true, typeAgreement: signAgreementSource, date: signAgreementEndTime ? signAgreementEndTime : '' } }
          }
        });
      }
      else {
        this.setState((state) => {
          if (signAgreementType == agreementOrRejection.已经签署) {
            return { ...state, clues: { showClues: false, ...state.clues }, agreement: { showAgreement: false, ...state.agreement } }
          } else if (signAgreementType == agreementOrRejection.拒绝签署) {
            return { ...state, clues: { showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: true, typeAgreement: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
          } else {
            if (signAgreementSource == merchantsType.新商户) {
              return { ...state, clues: { showClues: false, isConfirm: false, typeClues: merchantsType.新商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: false, typeAgreement: merchantsType.新商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            } else if (signAgreementSource == merchantsType.公转私商户) {
              return { ...state, clues: { showClues: true, isConfirm: true, typeClues: merchantsType.公转私商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: true, typeAgreement: merchantsType.公转私商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            }
          }
        });
      }
    }
    if (orgSignType === publicOrPrivate.对私商户) {
      //因对私商户会出现取消下发协议商户状态，所以加此判断
      if (signAgreementSource == merchantsType.取消下发协议商户) {
        let thirtyDay = 1000 * 60 * 60 * 24 * 30;
        let curDate = new Date().getTime();
        let endTime = new Date(signAgreementEndTime).getTime();
        if (thirtyDay > (curDate - endTime) && thirtyDay > Math.abs(curDate - endTime)) {
          signAgreementSource = merchantsType.历史团队版商户;
          signAgreementType = agreementOrRejection.待签署;
        } else {
          signAgreementType = agreementOrRejection.已经签署;
        }
      }
      if (isClose) {
        this.setState(state => {
          if (signAgreementType == agreementOrRejection.已经签署) {
            return { ...state, clues: { showClues: false, ...state.clues }, agreement: { showAgreement: false, ...state.agreement } }
          } else if (signAgreementType == agreementOrRejection.拒绝签署) {
            return { ...state, clues: { showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: true, typeAgreement: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
          } else {
            return { ...state, clues: { showClues: true, isConfirm: signAgreementType == agreementOrRejection.拒绝签署 ? false : true, typeClues: signAgreementType == agreementOrRejection.拒绝签署 ? merchantsType.拒绝签署商户 : signAgreementSource, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: signAgreementSource == merchantsType.新商户 ? false : true, typeAgreement: signAgreementSource, date: signAgreementEndTime ? signAgreementEndTime : '' } }
          }
        });
      }
      else {
        this.setState((state) => {
          if (signAgreementType == agreementOrRejection.已经签署) {
            return { ...state, clues: { showClues: false, ...state.clues }, agreement: { showAgreement: false, ...state.agreement } }
          } else if (signAgreementType == agreementOrRejection.拒绝签署) {
            return { ...state, clues: { showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: false, isClose: true, typeAgreement: merchantsType.拒绝签署商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
          } else {
            if (signAgreementSource == merchantsType.新商户) {
              return { ...state, clues: { showClues: false, isConfirm: false, typeClues: merchantsType.新商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: false, typeAgreement: merchantsType.新商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            } else if (signAgreementSource == merchantsType.历史团队版商户) {
              return { ...state, clues: { showClues: true, isConfirm: true, typeClues: merchantsType.历史团队版商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: true, typeAgreement: merchantsType.历史团队版商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            } else if (signAgreementSource == merchantsType.协议到期商户) {
              return { ...state, clues: { showClues: true, isConfirm: true, typeClues: merchantsType.协议到期商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: true, typeAgreement: merchantsType.协议到期商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            } else if (signAgreementSource == merchantsType.公转私商户) {
              return { ...state, clues: { showClues: true, isConfirm: true, typeClues: merchantsType.公转私商户, date: signAgreementEndTime ? signAgreementEndTime : '' }, agreement: { showAgreement: true, isClose: true, typeAgreement: merchantsType.公转私商户, date: signAgreementEndTime ? signAgreementEndTime : '' } }
            }
          }
        });
      }
    }

  };
  clickConfirm = () => {
    this.removeClose();
    this.setState({ agreement: { ...this.state.agreement, showAgreement: true, } })
  }
  protocolDialogClosed = (type) => {
    if (type === agreementOrRejection.已经签署) {
      notification.success({
        message: <p style={{ 'color': '#333' }}>恭喜您，签署成功</p>,
        duration: 4,
      });
      this.removeClose();
      this.setState({ clues: { ...this.state.clues, showClues: false }, agreement: { ...this.state.agreement, showAgreement: false } });
    }
    else if (type === agreementOrRejection.拒绝签署) {
      refusedSignedAgreement(Utils.getOrgId()).then(res => {
        const { data } = res;
        if (data.status === 200) {
          this.setState({ clues: { ...this.state.clues, showClues: true, isConfirm: false, typeClues: merchantsType.拒绝签署商户 }, agreement: { ...this.state.agreement, showAgreement: false } });
        }
      })
    }
    else if (type === agreementOrRejection.待签署) {
      if (!sessionStorage.getItem('isClose')) {
        sessionStorage.setItem('isClose', JSON.stringify(true))
      }
      this.setState({ clues: { ...this.state.clues, showClues: true }, agreement: { ...this.state.agreement, showAgreement: false } });
    }
  };
  removeClose = () => {
    if (sessionStorage.getItem('isClose')) {
      sessionStorage.removeItem('isClose');
    }
  };
  render() {
    let reactSwipeEl;
    const { clues, agreement } = this.state;
    return (
      <div className="homepage_v2">
        {
          clues.showClues && <div className='prompt-scene-bar'>
            <PromptSceneBar
              show={clues.showClues}
              isConfirm={clues.isConfirm}
              type={clues.typeClues}
              clickConfirm={this.clickConfirm}
              date={clues.date}
            />
          </div>
        }
        {
          this.state.isShowInactive && <PromptSceneBar
            show={true}
            isConfirm={''}
            type={'inactive'}
          />
        }
        <Spin spinning={this.state.pageLoading} className="spin-center">
          {
            !this.state.pageLoading &&
            <div>
              <CarouselCustom
                {...this.props}
              />
              <QueueAnim type='bottom'>
                {
                  !this.state.pageNamesConfig.notifyCardClose &&
                  <Row gutter={24} key="r1">
                      {/*通知*/}
                      <Col key="c1" span={Utils.isHLB() ? 24 : 16}>
                        <NotifyCard {...this.props} />
                      </Col>
                      {/*产品资料*/}
                      {
                        !Utils.isHLB() && <Col key="c2" span={8}>
                          {/*<div className="produce_info">*/}
                          <ProductCard />
                          {/*</div>*/}
                        </Col>
                      }
                  </Row>
                }
                <Row gutter={24} key="r2" style={{ marginTop: '24px' }}>
                    {/*数据统计*/}
                    <Col span={16} >
                      <div style={{ backgroundColor: 'white' }}>
                        <ActivityAndYesterday
                          pageLoading={this.state.pageLoading}
                          {...this.props}
                          {...this.state}
                        />
                      </div>
                    </Col>
                    {/*客户统计*/}
                    <Col span={8}>
                      <ClientCount
                        customerCount={this.state.customerCount}
                        pageLoading={this.state.pageLoading}
                        yesterdayCustomerCount={this.state.yesterdayCustomerCount}
                        pageConfig={this.state.pageNamesConfig.ClientCount}
                      />
                    </Col>
                </Row>
                <Row key="r3" style={{ marginTop: '24px' }}>
                  {/*柱状图-保费收入*/}
                  <Col span={16}>
                    <FeeCharts policyIncome={this.state.policyIncome} pageConfig={this.state.pageNamesConfig.Top5} />
                  </Col>
                  {/*昨日Top5*/}
                  <Col span={8}>
                    <Top5 {...this.props}
                      pageLoading={this.state.pageLoading}
                      yesterdayAgencyTopFive={this.state.yesterdayAgencyTopFive}
                      yesterdayProductTopFive={this.state.yesterdayProductTopFive}
                      pageConfig={this.state.pageNamesConfig.Top5}
                    />
                  </Col>
                </Row>
              </QueueAnim>
              <FootTool pageConfig={this.state.pageNamesConfig.FootTool} />
            </div>
          }

        </Spin>
        {
          !Utils.isHLB() && <div className='protocol_div'>
            <a style={{ marginRight: 4 }} href='https://cdn.zhongbaounion.com/share/register/user-agreement.html' target="_blank" rel='noopener noreferrer'>《服务协议》</a>
            <a href='https://cdn.zhongbaounion.com/share/register/privacy-policy.html' target="_blank" rel='noopener noreferrer'>《隐私政策》</a>
          </div>
        }
        <MyModal
          show={agreement.showAgreement}
          isClose={agreement.isClose}
          typeAgreement={agreement.typeAgreement}
          protocolDialogClosed={this.protocolDialogClosed}
          date={agreement.date}
        />
      </div>
    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}

export default connect(mapState)(HomePageV2)
